export const DEFAULT_WEEKS_MIN = 1
export const DEFAULT_WEEKS_MAX = 52
